import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";

export const getDateDistinct = async (instrumentID, accreditationType) => {
  try {
    let query = {
      query:
        `SELECT DISTINCT fromDate, toDate FROM cmc WHERE instrumentId = ${instrumentID} and fromDate IS NOT NULL AND toDate IS NOT NULL and accreditationType =${accreditationType} ORDER BY fromDate;`,
    };
    const response = await axiosWithToken.post(BASE_URL + "dynamic", query);
    return response.data;
  } catch (error) {
    console.log("fetch distinct date error", error);
  }
};

export const fetchInstrumentData = (params) => {
  let url = BASE_URL;
  return axiosWithToken
    .get(
      url +
        `xjoin?_join=inst.instruments,_j,ds.discipline&_on1=(inst.disciplineId,eq,ds.id)&_fields=ds.name,ds.id,inst.disciplineId,inst.id,inst.standardMasterIds,inst.uncertaintyFactors,inst.commonUncertaintyFactors,inst.supportiveInstrumentMasterData,inst.accreditationType,inst.instrumentName,inst.calibrationProcedureNo,inst.multipleCalibrationProcedureNo,inst.referenceStandards,inst.subGroup,inst.tablePartition,inst.isGauge,inst.formatNumber,inst.remarkId,inst.revisionNumber,inst.DatasheetRevisionDate,inst.DatasheetRevisionNumber,inst.datasheetFormatNumber,inst.sopUpload,inst.calMethod,inst.revisionDate&_where=(inst.id,eq,${params.id})`
    )
    .then((res) => {
      if (res.data.length) return res.data[0];
      return axiosWithToken
        .get(
          BASE_URL +
            `instruments?_fields=formatNumber,revisionNumber,datasheetFormatNumber,DatasheetRevisionNumber,DatasheetRevisionDate,remarkId,commonUncertaintyFactors,revisionDate,disciplineId,id,standardMasterIds,uncertaintyFactors,sopUpload,supportiveInstrumentMasterData,accreditationType,instrumentName,calibrationProcedureNo,multipleCalibrationProcedureNo,referenceStandards,subGroup,tablePartition,isGauge&_where=(id,eq,${params.id})`
        )
        .then((res) => {
          return res.data.map((e) => ({
            inst_disciplineId: e.disciplineId,
            inst_id: e.id,
            inst_standardMasterIds: e.standardMasterIds,
            inst_uncertaintyFactors: e.uncertaintyFactors,
            inst_accreditationType: e.accreditationType,
            inst_commonUncertaintyFactors: e.commonUncertaintyFactors,
            inst_supportiveInstrumentMasterData:
              e.supportiveInstrumentMasterData,
            inst_instrumentName: e.instrumentName,
            inst_sopUpload: e.sopUpload,
            inst_calibrationProcedureNo: e.calibrationProcedureNo,
            inst_multipleCalibrationProcedureNo: e.multipleCalibrationProcedureNo,
            inst_referenceStandards: e.referenceStandards,
            inst_subGroup: e.subGroup,
            inst_tablePartition: e.tablePartition,
            inst_isGauge: e.isGauge,
            inst_formatNumber: e.formatNumber,
            inst_revisionNumber: e.revisionNumber,
            inst_remarkId: e.remarkId,
            inst_revisionDate: e.revisionDate,
            inst_datasheetFormatNumber: e.datasheetFormatNumber,
            inst_DatasheetRevisionNumber: e.DatasheetRevisionNumber,
            inst_DatasheetRevisionDate: e.DatasheetRevisionDate,
          }))[0];
        });
    })
    .catch((err) => {
      console.log("fetch InstrumentData error", err);
    });
};

export const getUnitMasterArray = () => {
  let url = BASE_URL;
  return axiosWithToken
    .get(url + "unit?_where=(status,eq,1)")
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("fetch unit error", err);
    });
};

export const fetchDeciplineData = () => {
  let url = BASE_URL;
  return axiosWithToken
    .get(url + "discipline?_where=(status,eq,1)")
    .then((res) => res.data)
    .catch((err) => {
      console.log("fetch discipline error", err);
    });
};

export const fetchStandardsData = () => {
  let url = BASE_URL;
  let sqlQuery = {
    query: `SELECT disciplineId, standardName, validUpto, id, type, stId FROM standards WHERE id IN (SELECT MAX(id) FROM standards where status != -1 GROUP BY stId) AND status != -1`,
  };
  return axiosWithToken
    .post(url + "dynamic", sqlQuery)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("fetch standards error", err);
    });
};

export const fetchSupportiveData = () => {
  let url = BASE_URL;
  return axiosWithToken
    .get(
      url +
        "xjoin?_join=pl.standards,_j,pr.standardRanges&_on1=(pl.id,eq,pr.standardId)&_fields=pl.standardName,pr.rangeName,pl.id,pr.id,pl.stId&_where=(pl.status,eq,1)~and(pl.type,eq,2)"
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("fetch standards error", err);
    });
};

export const fetchUncertinityData = () => {
  let url = BASE_URL;
  return axiosWithToken
    .get(url + "uncertainty?_where=(status,eq,1)")
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("fetch uncertainty error", err);
    });
};
